import React from 'react';

const MasonryColumn = ({ index, isMobile, children }) => {

    const getColumnClassName = (i) => {
        let className = "mx-20 md:mx-10 3xs:mx-6";
        if (isMobile) {
            if (i === 0) className += " sm:mt-80 xs:mt-50";
            className += " w-1/2";
        } else {
            if (i === 0) className += " mt-292 md:mt-224";
            if (i === 2) className += " mt-160 md:mt-96";
            className += " w-1/3";
        }
        return className;
    }

    return (
        <div className={getColumnClassName(index)}>
            {children}
        </div>
    );
};

export default MasonryColumn;